export default __webpack_public_path__ + "static/media/project-status-advertising-campaign.3592dcf5.svg";